import Phaser from 'phaser';
import CloudGroup from './sprites/CloudGroup';

export default class {

  get dayColor() {
    return Phaser.Display.Color.HexStringToColor('#ffffff');
  }

  get sunsetColor() {
    return Phaser.Display.Color.HexStringToColor('#b58d5a');
  }

  get sunriseColor() {
    return Phaser.Display.Color.HexStringToColor('#e4d6c3');
  }

  get nightColor() {
    return Phaser.Display.Color.HexStringToColor('#0e3244');
  }

  get dayTime() {
    return 15000 / this.timeScale;
  }

  get sunsetTime() {
    return 15000 / this.timeScale;
  }

  get nightTime() {
    return 20000 / this.timeScale;
  }

  get sunriseTime() {
    return 15000 / this.timeScale;
  }

  constructor(scene) {
    this.scene = scene;
    this.time = 0;
    this.transitioning = false;

    this.tweenIndex = 0;
    this.timeScale = 1;

    this.color = this.dayColor;
    // tileSprite(x,y,w,h,key)
    this.xPos = -32;
    this.yPos = 64;
    this.skyWidth = 128;
    this.skyHeight = 96;
    this.yScale = 1;

    this.skyBG = this.scene.add.tileSprite(this.xPos, this.yPos, this.skyWidth, this.skyHeight, 'sky');
    this.skyBG.setOrigin(0, 1);

    this.clouds = new CloudGroup({
      scene: this.scene,
      count: 10
    });

    this.tweens = [];

    this.tweens.push(this.scene.add.tween({
      targets: this.sunriseColor,
      red: this.dayColor.red,
      green: this.dayColor.green,
      blue: this.dayColor.blue,
      ease: 'Linear',
      duration: this.dayTime,
      paused: true,
      onComplete: () => {
        //console.log("Going to sunset...")
        this.tweenIndex = 1;
        this.playCurrentTween();
      }
    }));

    this.tweens.push(this.scene.add.tween({
      targets: this.dayColor,
      red: this.sunsetColor.red,
      green: this.sunsetColor.green,
      blue: this.sunsetColor.blue,
      ease: 'Linear',
      duration: this.sunsetTime,
      paused: true,
      onComplete: () => {
        //console.log("Going to night...")
        this.tweenIndex = 2;
        this.playCurrentTween();
      }
    }));

    this.tweens.push(this.scene.add.tween({
      targets: this.sunsetColor,
      red: this.nightColor.red,
      green: this.nightColor.green,
      blue: this.nightColor.blue,
      ease: 'Linear',
      duration: this.nightTime,
      paused: true,
      onComplete: () => {
        //console.log("Going to sunrise...")
        this.tweenIndex = 3;
        this.playCurrentTween();
      }
    }));

    this.tweens.push(this.scene.add.tween({
      targets: this.nightColor,
      red: this.sunriseColor.red,
      green: this.sunriseColor.green,
      blue: this.sunriseColor.blue,
      ease: 'Linear',
      duration: this.sunriseTime,
      paused: true,
      onComplete: () => {
        //console.log("Going to day...")
        this.tweenIndex = 0;
        this.playCurrentTween();
      }
    }));
  }

  start() {
    this.playCurrentTween();
  }

  playCurrentTween() {
    this.tweens[this.tweenIndex].restart();
  }

  update(d) {
    this.tintTheSky();
    this.clouds.update(d);
  }

  tintTheSky() {
    this.currentTween = this.tweens[this.tweenIndex];
    let newColor = {
      r: this.currentTween.data[0].current,
      g: this.currentTween.data[1].current,
      b: this.currentTween.data[2].current
    };

    let newColorInt = Phaser.Display.Color.ObjectToColor(newColor).color;
    newColorInt = 0x00FFFFFF & newColorInt; // Remove alpha channel

    let args = [newColorInt, newColorInt, newColorInt - 0x101010, newColorInt - 0x101010];
    this.skyBG.setTint.apply(this, args);
    this.clouds.setTint.apply(this, args);
  }

  expand(x, y) {
    // Does sky need to grow? Do we extend to x,y? Maybe measure some buffer so we
    // are always covered for (y-32) or something.
    let topY = this.skyBG.getTopLeft().y;
    if (y - this.skyHeight / 2 < topY) {
      this.yScale += 1;
      console.log(`Sky: expanding to scale ${this.yScale}.`);

      this.skyBG.setScale(1, this.yScale);
      // Add more clouds?
      this.clouds.addClouds(10, topY);
    }
  }
}